import { GridStore } from '@roc/feature-app-core';
import { PaginationBar } from '@roc/ui';
import { observer } from 'mobx-react';
import { useStatusDashboardStyles } from './statusDashboardStyles';

// Empty, loading and error states of a paged table, and its pagination bar
export const GridFooter = observer(({ grid, emptyText }: { grid: GridStore; emptyText: string }) => {
  const classes = useStatusDashboardStyles();
  const { rows } = grid.gridData.data;

  if (grid.isError) {
    return <span className={classes.muted} style={{ padding: '16px 12px' }}>Could not load the data, please try again</span>;
  }
  if (grid.isLoading && !rows?.length) {
    return <span className={classes.muted} style={{ padding: '16px 12px' }}>Loading…</span>;
  }
  if (!rows?.length) {
    return <span className={classes.muted} style={{ padding: '16px 12px' }}>{emptyText}</span>;
  }
  return (
    <PaginationBar
      {...grid.gridData.meta}
      className={classes.paginationBar}
      onChange={(e, page) => grid.setPageNumber(page)}
    />
  );
});
